import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllFuncionarioTercUseCase } from "../../../presentation/useCases/read/get_all_funcionario_terc_use_case";
import { FuncionarioTercFilter } from "../../models/funcionario_terc_filter";
import { FuncionarioTercLista } from "../../models/funcionarios_tercerizado_lista";

import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";


// GetAllFuncionarioTercUseCase


export class GetAllFuncionarioTercUseCase
  extends BasePaginatedUseCase<FuncionarioTercLista>
  implements IGetAllFuncionarioTercUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {
    super();
  }

  async getAllListagemFuncionarioTerc(
    filter: FuncionarioTercFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    const response = await this.repository
      .getAllListagemFuncionarioTerc(
        filter,
        page,
        rowsPerPage,
      );
    
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
